import { authLogoutError } from '@store/slices/auth/authSlice.js';
import { BASE_URL } from '@utils/constants.js';
import { logoutClearStore } from '@utils/functions';
import httpClient from '@utils/httpClient';
import { call, put } from 'redux-saga/effects';

function logoutApiCall() {
  return httpClient.post(`api/account/logout`);
}

export function* logoutRequestSaga() {
  try {
    yield call(logoutApiCall);
    logoutClearStore();
    window.open(BASE_URL, '_self');

    // yield put(authLogoutSuccess());
  } catch (error) {
    yield put(authLogoutError(error));
  }
}
